import axiosInstance from "auth/FetchInterceptor";
import {
  REQUEST_ORDER_SEARCH_GRID,
  REQUEST_ORDER_DETAIL,
  REQUEST_ORDER_CREATE,
  REQUEST_ORDER_UPDATE,
  REQUEST_ORDER_UPDATE_PENDING_ITEMS,
  REQUEST_ORDER_SUBMIT,
  REQUEST_ORDER_BRANCH_APPROVE,
  REQUEST_ORDER_BRANCH_REJECT,
  REQUEST_ORDER_PURCHASING_APPROVE,
  REQUEST_ORDER_PURCHASING_REJECT,
  REQUEST_ORDER_DELETE,
  REQUEST_ORDER_CANCEL,
  REQUEST_ORDER_RESYNC_STATUS,
  REQUEST_ORDER_TRANSFER_SOURCE_STORES,
  REQUEST_ORDER_RESOLVE_TRANSFER_ITEMS,
  MENU_BADGES,
  EXPORT_EXCEL_REQUEST_ORDER,
} from "constants/ApiConstant";

import {
  currentStoreParams,
  withCurrentStore,
  withCurrentStoreInQuery,
} from "utils/currentStore";

const RequestOrderService = {};

RequestOrderService.getRequestOrder = function (data) {
  return axiosInstance.post(
    REQUEST_ORDER_SEARCH_GRID,
    withCurrentStoreInQuery(data),
  );
};

RequestOrderService.createRequestOrder = function (data) {
  return axiosInstance.post(REQUEST_ORDER_CREATE, withCurrentStore(data));
};

RequestOrderService.getTransferSourceStores = function (params) {
  return axiosInstance.get(REQUEST_ORDER_TRANSFER_SOURCE_STORES, {
    params: currentStoreParams(params),
  });
};

RequestOrderService.getMenuBadges = function (params) {
  return axiosInstance.get(MENU_BADGES, {
    params: currentStoreParams(params),
  });
};

RequestOrderService.exportExcel = function (params) {
  return axiosInstance.post(
    EXPORT_EXCEL_REQUEST_ORDER,
    withCurrentStore(params),
    {
      responseType: "blob",
    },
  );
};

RequestOrderService.getRequestOrderDetail = function (id) {
  return axiosInstance.get(`${REQUEST_ORDER_DETAIL}/${id}`);
};

RequestOrderService.updateRequestOrder = function (data) {
  return axiosInstance.put(REQUEST_ORDER_UPDATE, data);
};

RequestOrderService.updatePendingRequestOrderItems = function (data) {
  return axiosInstance.put(
    REQUEST_ORDER_UPDATE_PENDING_ITEMS,
    withCurrentStore(data),
  );
};

RequestOrderService.submitRequestOrder = function (id) {
  return axiosInstance.put(`${REQUEST_ORDER_SUBMIT}/${id}`);
};

RequestOrderService.approveBranchRequestOrder = function (id) {
  return axiosInstance.put(`${REQUEST_ORDER_BRANCH_APPROVE}/${id}`);
};

RequestOrderService.rejectBranchRequestOrder = function (data) {
  return axiosInstance.put(REQUEST_ORDER_BRANCH_REJECT, data);
};

RequestOrderService.approvePurchasingRequestOrder = function (id) {
  return axiosInstance.put(`${REQUEST_ORDER_PURCHASING_APPROVE}/${id}`);
};

RequestOrderService.rejectPurchasingRequestOrder = function (data) {
  return axiosInstance.put(REQUEST_ORDER_PURCHASING_REJECT, data);
};

RequestOrderService.delRequestOrder = function (id) {
  return axiosInstance.delete(`${REQUEST_ORDER_DELETE}/${id}`, null);
};

RequestOrderService.cancelRequestOrder = function (data) {
  return axiosInstance.put(REQUEST_ORDER_CANCEL, data);
};

RequestOrderService.resyncStatus = function (id) {
  return axiosInstance.put(`${REQUEST_ORDER_RESYNC_STATUS}/${id}`);
};

RequestOrderService.resolveTransferItems = function (data) {
  return axiosInstance.post(REQUEST_ORDER_RESOLVE_TRANSFER_ITEMS, data);
};

export default RequestOrderService;